module.exports = __webpack_public_path__ + "static/media/check.92b87809.svg";